import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Router, Scroll} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';

@Component({
    selector: 'app-for-business',
    templateUrl: './ai-landing.component.html',
    styleUrls: ['./ai-landing.component.scss']
})
export class AiLandingComponent implements OnInit {

    testName = 'anxiety';

    uid;

    startTextButtonText = 'Start test';
    apiUrl = environment.apiUrl;

    videoSrc = 'assets/img/animation/a_brain.webm';
    anchor = null;
    plansLoaded = null;

    constructor(
        private router: Router,
        public auth: AuthService,
        private device: DeviceDetectorService,
        private flowTypeService: FlowTypeService
    ) {
        this.router.events.subscribe((event: any) => {
            if (event instanceof Scroll && event.anchor) {
                setTimeout(() => {
                    this.anchor = event.anchor;
                }, 100);
            } else {
                this.anchor = null;
            }
        });
    }

    ngOnInit() {
        this.flowTypeService.state = 'ai';
        if (this.device.browser.toLowerCase() === 'safari') {
            this.videoSrc = null;
        }
        this.startTextButtonText = this.auth?.userState?.trial ? 'Free trial' : 'Start test';
    }

    onPubLoaded() {
        if (this.anchor && this.plansLoaded) {
            this.scroll('#' + this.anchor);
        }
    }

    private scroll(query: string) {
        const targetElement = document.querySelector(query);
        if (!targetElement) {
            // window.scrollTo(80, 80);
        } else if (!this.isInViewport(targetElement)) {
            // targetElement.scrollIntoView();
        }
    }

    private isInViewport = (elem: any) => {
        const bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    goToLink(url: string) {
        window.open(url, '_blank');
    }

    void(event: any) {
        event.preventDefault();
    }

    onPlansLoaded(prop: any) {
        this.plansLoaded = true;
        this.onPubLoaded();
        // if (window.location.hash) {
        //     this.scrollToFirstInvalidControl(window.location.hash);
        // }
    }

    async goToTest() {
        return this.router.navigate(
            ['cs'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onPaymentSuccess(prop) {

        if (prop) {
            this.goToTest().then();
        }
    }

}
